<template>
  <div class="row py-3 mb-3 header-edit">
    <div class="col-12 col-lg-11 col-xl-11 col-md-11 pr-0 customer-info-wrapper">
      <div class="header-background position-relative flex-column flex-lg-row flex-xl-row flex-md-row">
        <div class="col-12 col-xl-2 col-lg-2 col-md-2 customer-name">
          <div class="d-flex align-items-center">
            <template v-if="canSeeCustomerInfo || $_can('customer-info-subco.show')">
              <h2 class="pointer"
                  @click="isActive && $emit('showCustomerModal')"
              >
                {{ job.customer.first_name }}
                {{ job.customer.last_name }}
              </h2>
            </template>
            <template v-else>
              <h2>
                {{ job.customer.first_name }}
                {{ job.customer.last_name }}
              </h2>
            </template>
            <div class="position-relative mt-1">
              <span v-if="job.has_subscription" @click="showMembershipPerks = true" class="mod-icon-membership d-inline-block ml-3 pointer" />
              <MembershipPerks v-if="showMembershipPerks" @close="showMembershipPerks = false" />
              <span v-if="job.recurly_subscription_id" class="mod-icon-recurly-subscription d-inline-block ml-3 pointer" />
              <span v-if="job.second_customer" @click="showSecondCustomerInfo = true" class="fa fa-user d-inline-block ml-3 pointer" />
              <SecondCustomerInfo :customer="job.second_customer" v-if="job.second_customer && showSecondCustomerInfo" @close="showSecondCustomerInfo = false" />
            </div>
          </div>
        </div>
        <div
          v-if="canSeeCustomerInfo || $_can('customer-info-subco.show')"
          class="d-flex flex-column d-lg-block d-xl-block d-md-block customer-info-content"
          :class="[customerHasRated || job.status_id === 16 ? 'col-12 col-lg-7 col-md-7 col-xl-7' : 'col-12 col-md-9 col-lg-9 col-xl-9']"
        >
          <small class="mr-4 header-icon">
            <span class="mod-icon-edit mod-icon-phone" aria-hidden="true" />
            {{ job.customer.phone ? phoneMask.maskedPhone(job.customer.phone) : 'No phone added' }}
          </small>
          <small class="mr-4 header-icon">
            <span class="mod-icon-edit mod-icon-email" aria-hidden="true" />
            {{ job.customer.email }}
            <span v-show="contactEmails()" class="btn-status btn-active">+{{ contactEmails() }}</span>
          </small>
          <small v-if="job.customer.customer_cards && job.customer.customer_cards.length"
                 class="mr-4 header-icon"
          >
            <span class="mod-icon-edit mod-icon-cc" aria-hidden="true" />
            **** {{ job.customer.customer_cards.find(c => c.is_default === 1).card_number }}
          </small>
          <small v-else class="mr-4 header-icon">
            <span class="mod-icon-edit mod-icon-cc" aria-hidden="true" />
            No credit card added
          </small>
        </div>
        <div
          v-if="canSeeCustomerInfo || $_can('customer-info-subco.show')"
          class="col-1 header-icon customer-edit text-right"
        >
          <span class="fa fa-pencil pointer"
                :class="{'disabled': !hasAccess || job.is_flat_rate}"
                v-if="isActive"
                @click="openCustomerModal"
          />
        </div>
        <div class="col-2 d-flex align-items-center customer-edit justify-content-end">
          <span class="pr-2" v-if="customerHasRated">
            {{ job.customer_rating.rating }}
          </span>
          <button
            v-if="job.status_id === 16"
            class="btn btn-customer-rating pointer p-1"
            @click="$emit('review')"
          >
            <i class="fa fa-star" :class="[customerHasRated ? 'rated' : '']" />
          </button>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-1 col-md-1 col-xl-1 pl-1">
      <button :disabled="canLeaveNote || !hasAccess"
              class="btn btn-secondary pull-right"
              @click="showModalCustomerNote = !showModalCustomerNote"
      >
        <template v-if="job.customer_note">View note</template>
        <template v-else>Add note</template>
        <i class="fa text-secondary"
           aria-hidden="true"
           :class="showModalCustomerNote ? 'fa fa-caret-up' : 'fa fa-caret-down'"
        />
      </button>
      <customer-note v-if="showModalCustomerNote"
                     :customer-note="customerNote"
                     :model="'jobs'"
                     :model-id="job.id"
                     :note-id="job.customer_note ? job.customer_note.id : null"
                     :user-id="userId"
                     :status-name="job.status && job.status.name"
                     @close="showModalCustomerNote = !showModalCustomerNote"
                     @ok="saveCustomerNote"
      />
      <error-field :errors="errors" field="customer" />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import CustomerNote from '../CustomerNote';
import PhoneMask from '../../classes/PhoneMask';
import Errors from '../../classes/Errors';
import MembershipPerks from '../MembershipPerks';
import SecondCustomerInfo from './modals/SecondCustomerInfo.vue';

export default {
  components: {
    CustomerNote,
    MembershipPerks,
    SecondCustomerInfo,
  },
  props: {
    job: {
      type: Object,
      default: () => {},
    },
    userId: {
      type: Number,
      default: null,
    },
    hasAccess: {
      type: Boolean,
      default: false,
    },
    customerNote: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    canSeeCustomerInfo: false,
    customerRating: false,
    errors: new Errors(),
    phoneMask: new PhoneMask(),
    showMembershipPerks: false,
    showModalCustomerNote: false,
    showSecondCustomerInfo: false,
  }),
  computed: {
    canLeaveNote() {
      return (
        (this.job.status.name === 'Canceled' || this.job.status.name === 'Completed') &&
        !this.job.customer_note
      );
    },
    isActive() {
      return (
        this.job.status &&
        this.job.status.name !== 'Canceled' &&
        this.job.status.name !== 'Completed'
      );
    },
    customerHasRated() {
      return this.job.customer_rating;
    },
  },
  watch: {
    job() {
      this.checkDate();
    },
  },
  mounted() {
    this.checkDate();
  },
  methods: {
    contactEmails() {
      let count = 0;
      if (this.job.customer.contacts) {
        this.job.customer.contacts.forEach(contact => {
          if (contact.email || contact.phone) {
            count += 1;
          }
        });
      }
      return count;
    },
    checkDate() {
      if (
        moment(this.job.move_date, 'MM-DD-YYYY h:m a').format('YYYY-MM-DD') <=
        moment()
          .subtract('1', 'd')
          .format('YYYY-MM-DD')
      ) {
        this.canSeeCustomerInfo = true;
      } else if (
        moment(this.job.move_date, 'MM-DD-YYYY h:m a').format('YYYY-MM-DD') ===
        moment().format('YYYY-MM-DD')
      ) {
        this.canSeeCustomerInfo = true;
      } else if (
        moment(this.job.move_date, 'MM-DD-YYYY h:m a').format('YYYY-MM-DD') ===
        moment()
          .add('1', 'd')
          .format('YYYY-MM-DD')
      ) {
        this.canSeeCustomerInfo = true;
      } else {
        this.canSeeCustomerInfo = false;
      }
    },
    openCustomerModal() {
      if (this.hasAccess && !this.job.is_flat_rate) {
        this.$emit('showCustomerModal');
      }
    },
    saveCustomerNote(callback) {
      this.$emit('saveCustomerNote', () => {
        callback();
        this.showModalCustomerNote = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.rated {
  color: #f59f01;
}
.btn-customer-rating {
  min-width: 30px;
  background-color: #80808087;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/JobCustomerInfo.vue